<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V3YESr/tc-custom/9781504065146.jpg?1737121728562" alt="This image is the cover for the book Charles Dickens Collection Volume Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Charles Dickens Collection Volume Two
      </h1>
      <p class="bookDescription body article font2">
        <b>Three classic novels of wealth, poverty, murder, and ambition from the greatest storyteller of the Victorian era.</b><br/><br/> Filled with drama, emotion, and suspense, these three novels have compelled and delighted readers for well over a century.<br/>  <br/><i>Martin Chuzzlewit</i>: After losing his inheritance, a young man strives to make his own fortune, in this witty, wide-ranging saga.<br/>  <br/><i>Nicholas Nickleby</i>: A young man fights to save his mother, his sister, and a group of abused schoolboys in this novel of hardship and heroism.<br/>  <br/><i>Our Mutual Friend</i>: When a corpse is found in the River Thames, it will alter the course of several lives.<br/>  <br/> “In addition to its realistic police procedures and incisive criminal psychology, <i>Our Mutual Friend</i> is steeped in the gloomy atmosphere and foreboding imagery that one associates with the modern suspense thriller.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Dickens
      </h2>
      
      <p class="authorDescription body article">An international celebrity during his lifetime, Charles Dickens (1812&shy;&ndash;1870) is widely regarded as the greatest novelist of the Victorian era. His classic works include&#160;<I>A Christmas Carol</I>,&#160;<I>Oliver Twist</I>,&#160;<I>David Copperfield</I>,&#160;<I>Great Expectations</I>, and&#160;<I>A Tale of Two Cities</I>, one of the bestselling novels of all time. When Dickens was twelve years old, his father was sent to debtors&rsquo; prison, and the boy was forced to work in a boot-blacking factory to support his family. The experience greatly shaped both his fiction and his tireless advocacy for children&rsquo;s rights and social reform.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58dfc7b0